import axiosClient from "./n8nClient";

class DatService {
    constructor() {
        this.dat = axiosClient;
    }

    async query(params) {
        return this.dat.get("/dat", {
            params
        });
    }

    async search(params) {
        return this.dat.get("/dat/search", {
            params
        });
    }

    async searchFinalResult(params) {
        return this.dat.get("/dat/search/final", {
            params
        });
    }

    async sync(provider, startDate, endDate) {
        const url = `/dat/sync/${provider}`;
        return this.dat.post(url, {
            startDate,
            endDate
        });
    }

    async calcTotalDistance() {
        const url = `/dat/calc`;
        return this.dat.get(url);
    }

    async searchFirstCheckStudent() {
        return this.dat.get("/dat/student/first-check");
    }

    async searchSecondCheckStudent() {
        return this.dat.get("/dat/student/second-check");
    }

    async updateStudent(data) {
        return this.dat.patch("/dat/student", data);
    }

    async update(data) {
        return this.dat.patch("/dat", { ...data, excel_sync: null });
    }

    async markTPDat(id, mark) {
        return this.dat.patch("/dat/tp/mark", {
            id,
            mark
        });
    }

    async getPlate() {
        return this.dat.get("/dat/plate");
    }

    async searchStudent(params) {
        return this.dat.get("/dat/search/student", {
            params
        });
    }

    async syncStudent() {
        return this.dat.post("/dat/sync/student");
    }

    async login(username, password) {
        const data = {
            username,
            password
        };
        return this.dat.post("dat/login", data);
    }

    async checkError() {
        return this.dat.post("/dat/check-error");
    }
}

const datService = new DatService();
export default datService;
